export default "__VITE_ASSET__BTpPsCc___"